/**
 * Form validation
 *
 * @since 1.0.0
 */
// import 'script-loader!hyperform/dist/hyperform.js' // use to make ie11 work locally
import hyperform from 'hyperform' // eslint-disable-line

const FormValidation = () => {
  const forms = document.querySelectorAll('.js-form,.js-steps-form-form')
  if (! forms) return

  ;[...forms].forEach(form => {

    hyperform(window) // window.hyperform(form)
    const inputs = form.querySelectorAll('input,textarea,select')

    ;[...inputs].forEach(input => {
      if (input.required) { // All required inputs
        input.addEventListener('invalid', e => e.preventDefault())
      }
    })

    // register a custom validator for sum
    const sum = form.querySelector('input[name="sum"]')

    if (sum) {
      hyperform.addValidator( form.querySelector('input[name="sum"]'), (element) => {
        const nr_1 = form.querySelector('input[name="nr_1"]')
        const nr_2 = form.querySelector('input[name="nr_2"]')
        const answer = parseInt(nr_1.value) + parseInt(nr_2.value)
    
        let valid = parseInt(element.value) === answer
        element.setCustomValidity( valid ? '' : 'Wrong answer' )
    
        return valid
      })
    }

  }) // End forEach

}

export default FormValidation



// WEBPACK FOOTER //
// ./src/js/modules/FormValidation.js